import { Transform } from '@warp-drive/legacy/serializer/transform';
import { typeOf } from '@ember/utils';

export default class ArrayString extends Transform {
  deserialize(serialized) {
    return typeOf(serialized) === 'array' ? serialized : [];
  }

  serialize(deserialized) {
    switch (typeOf(deserialized)) {
      case 'array':
        return deserialized;

      case 'string':
        return deserialized.split(',').map(function (item) {
          return item.trim();
        });

      default:
        return [];
    }
  }
}
